import formatDistance from 'date-fns/formatDistance'
import { RoundImage, FlexBox, Text } from '@fable/components'
import { Review } from '@fable/types'
import { css, useTheme } from '@fable/theme'
import Dropdown from 'components/dropdown'
import { useActions } from 'hooks'
import { BookDetailReviewShareOptions } from './BookDetailReviewShareOptions'
import { Link } from 'react-router-dom'
import { getSlug } from 'utils'

export const BookDetailReviewHeader = ({
  review,
  mini,
}: {
  review: Review
  mini: boolean
}) => {
  const { openModal } = useActions()
  const { colors } = useTheme()
  const user = review.user

  return (
    <FlexBox
      className={css`
        position: relative;
      `}
      justifyContent="space-between"
      alignItems="center"
    >
      <Link
        to={`/${getSlug(user.url)}`}
        target="_blank"
        className={css`
          * {
            cursor: pointer;
          }
        `}
      >
        <FlexBox alignItems="center">
          <RoundImage
            src={user.pic || ''}
            alt={`${user.display_name} Avatar`}
            size={100}
            diameter="36px"
          />
          <div
            className={css`
              margin-left: 8px;
            `}
          >
            <Text
              className={css`
                letter-spacing: -0.2px;
              `}
              tag="p"
              type="subhead"
              sizing="XS"
            >
              {user.display_name}
            </Text>
            <Text
              className={css`
                margin-top: 2px;
              `}
              type="label"
              sizing="L"
              color={colors.greyNeutral}
            >
              Created&nbsp;
              {formatDistance(new Date(review.created_at), new Date(), {
                addSuffix: true,
              })}
            </Text>
          </div>
        </FlexBox>
      </Link>
      {mini ? null : (
        <Dropdown
          control
          anchor="top"
          controlDirection="horizontal"
          containerClass={css`
            .fds-ui--dropdown-item {
              padding: 10px 15px;
            }
            .dropdown-control {
              span {
                width: 3px;
                height: 3px;
                background: ${colors.greyNeutral} !important;
                &:hover {
                  opacity: 0.8;
                }
              }
            }
          `}
          items={[
            {
              title: 'Share',
              action: () =>
                openModal(
                  <BookDetailReviewShareOptions
                    url={review.url as string}
                    book={review.book}
                  />,
                  'm-card'
                ),
            },
            {
              title: 'Report',
              action: () => window.open('https://help.fable.co/', '_blank'),
            },
          ]}
        />
      )}
    </FlexBox>
  )
}
